import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';
import { Store } from '@ngrx/store';
import * as fromTap from 'app/state/tap';
import * as fromCo2 from 'app/state/co2-bottle';
import { CommonModule } from '@angular/common';
import { IPlaato2VM } from 'app/models/plaato2';
import { ICO2Bottle } from 'app/models/co2-bottle';

@Component({
  selector: 'app-select-plaato',
  templateUrl: './select-plaato.component.html',
  styleUrls: ['./select-plaato.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule],
  changeDetection: ChangeDetectionStrategy.OnPush,

})
export class SelectPlaato2Component {

  private plaatosWithTap = this.store.selectSignal(fromTap.getPlaato2sWithTap);
  private bottles = this.store.selectSignal(fromCo2.selectAllItems);

  // Each plaato is shown with what it is currently linked to: tap (from the selector)
  // and/or CO2 bottle (co2Bottles.plaato2Id) — one device at a time.
  items = computed(() =>
    this.plaatosWithTap().map(p => ({
      ...p,
      co2Bottle: this.bottles().find(b => b.plaato2Id === p.id),
    } as IPlaato2VM & { co2Bottle?: ICO2Bottle })),
  );

  constructor(
    private store: Store,

    private modalController: ModalController,
  ) { }


  closeModal() {
    this.modalController.dismiss();
  }

  selectItem(item: IPlaato2VM) {
    this.modalController.dismiss({
      item
    });
  }







}
